export const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

export const validatePhoneNumber = (phone) => {
    return String(phone)
        .toLowerCase()
        .match(
            /^\+?\d{10,12}$/
        );
};

export const getFullDate = (date) => {
    if (!date) return '';
    const fullDate = new Date(date);
    const year = fullDate.getFullYear();
    const month = String(fullDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(fullDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const formatDate = (dateString, format="dd-mm-yyyy") => {
    const [year, month, day] = dateString.split('-');
    let formattedDate = '';

    // Iterate over the format string and build the formatted date
    format.split('-').forEach((part, index) => {
        if (part === 'dd') {
            formattedDate += day;
        } else if (part === 'mm') {
            formattedDate += month;
        } else if (part === 'yyyy') {
            formattedDate += year;
        }

        // Add a dash between parts, except after the last part
        if (index < format.split('-').length - 1) {
            formattedDate += '-';
        }
    });

    return formattedDate;
};

export const capitalize = (string) => {
    return string[0].toUpperCase() + string.slice(1).toLowerCase();
}